// BackgroundComponent.js
import React from "react";

const BackgroundComponent = () => {
  return (
    <>
      {/* Floating Clouds and Stars */}
      <div className="clouds animate-clouds absolute top-10 left-10 w-32 h-32 bg-[url('https://app.velammalonline.com/images/new_images/cloud-img6.png')] bg-contain bg-no-repeat opacity-70 z-0"></div>
      <div className="star animate-blink absolute top-24 right-24 w-8 h-8 bg-[url('https://app.velammalonline.com/images/new_images/star1.svg')] bg-contain bg-no-repeat opacity-80 z-0"></div>
      <div className="star animate-blink absolute bottom-32 left-20 w-8 h-8 bg-[url('https://app.velammalonline.com/images/new_images/star2.svg')] bg-contain bg-no-repeat opacity-60 z-0"></div>
      <div className="clouds animate-clouds absolute bottom-0 left-1/2 transform -translate-x-1/2 w-28 h-28 bg-[url('https://app.velammalonline.com/images/new_images/cloud-img6.png')] bg-contain bg-no-repeat opacity-50 z-0"></div>
    </>
  );
};

export default BackgroundComponent;
